var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIllustration = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 149,
    viewBox: "0 0 166 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.824 22.8851L107.316 17.6563C105.534 16.6765 103.37 16.699 101.609 17.7156L32.9826 57.3372C30.7837 58.6068 29.2741 60.1861 28.9681 62.1952L38.1457 67.5495L116.824 22.8851Z",
    fill: "#FFD1C4",
    stroke: "#040222",
    strokeWidth: 2.53134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5114 66.4502L29.375 61.0933C28.6564 62.3878 28.914 62.9848 28.8404 64.1268L28.7289 122.908C28.7251 124.912 29.7538 126.777 31.4509 127.842L39.4287 132.85L37.5114 66.4502Z",
    fill: "#FFD1C4",
    stroke: "#040222",
    strokeWidth: 2.53134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6464 129.744L37.0963 68.4531C37.0846 67.1437 37.7785 65.9294 38.9125 65.2746L112.743 22.6484C115.158 21.2543 118.178 22.9879 118.192 25.7761L118.5 87.2065C118.507 88.5108 117.814 89.7184 116.684 90.3706L43.0951 132.857C40.6859 134.248 37.6714 132.526 37.6464 129.744Z",
    fill: "#FFF6F3",
    stroke: "#040222",
    strokeWidth: 2.53134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5271 95.0679L50.3631 113.149",
    stroke: "#040222",
    strokeWidth: 2.53134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1796 93.3818L50.1881 82.1911C50.1887 81.4268 50.6027 80.7225 51.2703 80.3503L62.207 74.2524C63.6137 73.4681 65.3449 74.4859 65.3437 76.0964L65.3358 86.4837C65.3352 87.2072 64.9639 87.8799 64.352 88.266L53.4147 95.1674C52.0094 96.0541 50.1783 95.0434 50.1796 93.3818Z",
    fill: "#FFD1C4",
    stroke: "black",
    strokeWidth: 2.53134
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9383 76.2345L57.9384 82.1953M57.9384 91.7844L57.9384 86.6012M57.9384 86.6012L50.8762 90.2944M57.9384 86.6012L57.9384 82.1953M57.9384 86.6012L65.4541 82.6239M57.9384 82.1953L50.4875 85.8237M57.9384 82.1953L65.4541 78.308",
    stroke: "black",
    strokeWidth: 1.07582
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.614 81.8283C115.149 83.3595 117.149 84.7468 119.532 86.0792L135.067 95.0388C136.735 96.0112 137.427 97.0756 137.422 98.106V129.325C136.683 131.562 133.31 135.629 125.727 134C117.405 129.597 109.375 125.012 104.042 121.787C100.128 119.42 97.97 115.205 97.9261 110.63C97.8487 102.562 97.6893 91.7573 97.5976 86.0792C96.8687 82.422 106.206 77.9579 112.614 81.8283Z",
    fill: "#FFD1C4",
    stroke: "#040222",
    strokeWidth: 2.26197
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M113.935 106.565C116.248 110.135 114.32 112.951 113.046 113.467V118.602L109.631 116.727V111.348C109.197 110.858 108.694 109.869 108.395 108.573C107.824 106.096 110.697 101.57 113.935 106.565Z",
    fill: "#040222",
    stroke: "#00072A",
    strokeWidth: 2.26197
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M123.416 102.165C118.576 99.6288 105.268 91.6439 99.2182 87.9684C98.2691 87.3957 97.7696 86.7317 97.6315 86.0389C96.9026 82.3818 106.24 77.9176 112.647 81.788C115.183 83.3192 117.183 84.7065 119.566 86.0389L135.101 94.9985C136.769 95.971 137.461 97.0353 137.456 98.0657C137.436 101.709 128.688 104.928 123.416 102.165Z",
    fill: "#FFA38A",
    stroke: "#040222",
    strokeWidth: 2.26197
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M116.14 64.5913C121.588 66.2216 125.328 72.6344 125.328 77.3073V89.7976V97.8482C125.328 98.283 125.784 99.1525 127.605 99.1525C129.426 99.1525 129.936 98.283 129.963 97.8482C129.949 96.376 129.933 94.4638 129.92 92.382C129.883 86.4724 129.867 79.196 129.963 76.7367C130.232 69.8512 123.632 59.9452 115.327 59.2116C107.022 58.478 105.977 64.5913 105.977 66.6292V85.6215C106.085 86.2192 106.692 87.4473 108.253 87.5777C109.814 87.7082 110.367 86.3279 110.449 85.6215V67.0368C110.449 65.8956 110.693 62.9611 116.14 64.5913Z",
    fill: "#F7F4FD",
    stroke: "#040222",
    strokeWidth: 2.26197
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIllustration);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/illustration.bace9b720b783bf37a8ed256963bad63.svg";